import store from "src/store";

const ConfigsSearcher = () => {
  const configs = store.getState().gamma.appConfig;
  if (configs) {
    const configFinder = (str) => {
      if (configs?.length) {
        const keyValue = configs?.find((obj) => obj.key === str);
        return keyValue?.value || false;
      }
    };
    return { configFinder };
  }
  return { configs };
};

export default ConfigsSearcher;
